
/* ============= */
/*   PONYFILLS   */
/* ============= */
/* Override native functions without affecting global environment <3 */

// requestAnimationFrame
var requestAnimationFrame = function(callback) {
  let self = requestAnimationFrame;
  if (self.win.requestAnimationFrame) return self.win.requestAnimationFrame.apply(self.win, arguments);
  else {
    self.queue.push(callback);
    if (!self.timeout) {
      self.timeout = setTimeout(() => {
        let queue = self.queue;
        self.queue = [];
        self.timeout = null;
        queue.forEach(q => {
          q();
        });
      }, 16);
    }
  }
};
requestAnimationFrame.queue   = [];
requestAnimationFrame.timeout = null;
requestAnimationFrame.win     = document.body && /(^|\s)slaask-iframe($|\s)/.test(document.body.className)
                                ? window.parent
                                : window;




/* ============= */
/*   POLYFILLS   */
/* ============= */

if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    }
    if (start === undefined) { start = 0; }
    return this.indexOf(search, start) !== -1;
  };
}

// NodeList.forEach
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
  if (window.parent)
    window.parent.NodeList.prototype.forEach = window.parent.Array.prototype.forEach;
}

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector ||
    Element.prototype.oMatchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    function(s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
}
